import type { NeedsYouSnoozeRecord } from '@tenfour/domain'

/**
 * localStorage store for the Needs-you checkmark's local snooze — the kinds
 * with no backend ack (conversations, invoices) hide client-side until they
 * get new activity or the snooze ages out (`isNeedsYouSnoozeActive` in
 * @tenfour/domain owns that logic). Records are keyed by feed item id.
 */
const storageKey = (accountId: string) => `tt_needs_you_snoozed:${accountId}`

export function readSnoozed(accountId: string): Record<string, NeedsYouSnoozeRecord> {
  try {
    const raw = localStorage.getItem(storageKey(accountId))
    if (!raw) return {}
    const parsed: unknown = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object') return {}
    const out: Record<string, NeedsYouSnoozeRecord> = {}
    for (const [id, rec] of Object.entries(parsed as Record<string, unknown>)) {
      if (
        rec &&
        typeof rec === 'object' &&
        typeof (rec as NeedsYouSnoozeRecord).at === 'string' &&
        typeof (rec as NeedsYouSnoozeRecord).snoozedAtMs === 'number'
      ) {
        out[id] = rec as NeedsYouSnoozeRecord
      }
    }
    return out
  } catch {
    return {}
  }
}

export function writeSnoozed(
  accountId: string,
  snoozed: Record<string, NeedsYouSnoozeRecord>,
): void {
  try {
    localStorage.setItem(storageKey(accountId), JSON.stringify(snoozed))
  } catch {
    // Quota / privacy mode — the snooze just won't survive a reload.
  }
}
